import { observer } from "mobx-react-lite";
import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";

import Button from "../../../../components/button/Button";
import { api } from "../../../../services/api/ApiService";
import { MyOrganizationInvitationsStorageModel } from "../../../../services/organization/MyOrganizationInvitationsStorage";
import useThemeService from "../../../../services/theme-service/ThemeService";

export default observer(function AcceptCollaborationButton() {
  const { themeClass } = useThemeService();
  const history = useHistory();

  const [myOrganizationInvitationsStorage] = useState(() =>
    MyOrganizationInvitationsStorageModel.create({ useGridFiltering: true }, { api })
  );

  const goToInvitations = useCallback(() => {
    history.push("/my-account/organizations/collaboration-requests");
  }, [history]);

  return (
    <Button
      id="accept-collaboration"
      textKey="general.accept.collaboration"
      className={themeClass(["btn-big", "fill-color-ghost"])}
      onClick={goToInvitations}
      disabled={!myOrganizationInvitationsStorage.hasAvailableItems}
    />
  );
});
